import React, { useState, useEffect } from "react";
import source from "./data/reapit_ddm.json";
import ReapITProperty from "./reapitproperty";

const ReapITDDM = () => {
  const [Loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <div>
      <h1>ReapIT Property data - DDM</h1>
      <p style={{ marginBottom: "2rem" }}>
        <a href="/" title="Main Menu link">
          Return to main menu
        </a>
      </p>
      {Loading && <h4>Loading data...</h4>}

      {!Loading && (
        <>
          {source.map((itm) => (
            <ReapITProperty Data={itm} key={itm.id} />
          ))}
        </>
      )}
    </div>
  );
};

export default ReapITDDM;
